// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeltaForm_root__JGHCe {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
}
.DeltaForm_root__JGHCe .DeltaForm_header__YgzRv {
  padding: 0 24px;
  font-size: 20px;
  font-weight: 300;
  color: #111111;
}
.DeltaForm_root__JGHCe thead th {
  font-size: 10px;
  line-height: 24px;
  color: #111111;
  text-wrap: nowrap;
}
.DeltaForm_root__JGHCe tbody td {
  font-size: 10px;
  color: rgba(17, 17, 17, 0.6392156863);
  letter-spacing: 0.1px;
  text-transform: capitalize;
  vertical-align: middle;
}
.DeltaForm_root__JGHCe tbody tr.DeltaForm_active__pVsRY td {
  background-color: #f2f2f2;
}
.DeltaForm_root__JGHCe .DeltaForm_actions__NFO3N {
  display: flex;
  gap: 8px;
}
.DeltaForm_root__JGHCe .DeltaForm_actions__NFO3N svg {
  cursor: pointer;
}
.DeltaForm_root__JGHCe .DeltaForm_actions__NFO3N svg.DeltaForm_disabled__sLXjv {
  cursor: default;
}
.DeltaForm_root__JGHCe .DeltaForm_hideSelectionColumn__nnZyi tr > :first-child {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/DeltaForm/DeltaForm.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;AACJ;AAAI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEN;AAAI;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAEN;AAAI;EACE,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;AAEN;AAAI;EACE,yBAAA;AAEN;AAAI;EACE,aAAA;EACA,QAAA;AAEN;AADM;EACE,eAAA;AAGR;AAFQ;EACE,eAAA;AAIV;AAEM;EACE,aAAA;AAAR","sourcesContent":[".root {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding: 16px 0;\r\n    .header {\r\n      padding: 0 24px;\r\n      font-size: 20px;\r\n      font-weight: 300;\r\n      color: #111111;\r\n    }\r\n    thead th {\r\n      font-size: 10px;\r\n      line-height: 24px;\r\n      color: #111111;\r\n      text-wrap: nowrap;\r\n    }\r\n    tbody td {\r\n      font-size: 10px;\r\n      color: #111111A3;\r\n      letter-spacing: 0.1px;\r\n      text-transform: capitalize;\r\n      vertical-align: middle;\r\n    }\r\n    tbody tr.active td {\r\n      background-color: #f2f2f2;\r\n    }\r\n    .actions {\r\n      display: flex;\r\n      gap: 8px;\r\n      svg {\r\n        cursor: pointer;\r\n        &.disabled {\r\n          cursor: default;\r\n        }\r\n      }\r\n    }\r\n  \r\n    .hideSelectionColumn {\r\n      tr > :first-child {\r\n        display: none;\r\n      }\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `DeltaForm_root__JGHCe`,
	"header": `DeltaForm_header__YgzRv`,
	"active": `DeltaForm_active__pVsRY`,
	"actions": `DeltaForm_actions__NFO3N`,
	"disabled": `DeltaForm_disabled__sLXjv`,
	"hideSelectionColumn": `DeltaForm_hideSelectionColumn__nnZyi`
};
export default ___CSS_LOADER_EXPORT___;
